import { render, staticRenderFns } from "./DepTree.vue?vue&type=template&id=2f69f76b&scoped=true"
import script from "./DepTree.vue?vue&type=script&lang=ts"
export * from "./DepTree.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f69f76b",
  null
  
)

export default component.exports